import ViewDepthBotContainer from './view-depth-bot-container';

export default ViewDepthBotContainer;
